export default __webpack_public_path__ + "static/media/verify-email.84ed55af.svg";